import { ColorTokens, } from '@voltmoney/schema';
export const CarousalMock = {};
export const args = {
    data: [
        {
            id: '1',
            image: 'https://volt-images.s3.ap-south-1.amazonaws.com/onboard1.svg',
            text: 'Unlock cash from mutual fund savings in 5 mins',
        },
        {
            id: '2',
            image: 'https://volt-images.s3.ap-south-1.amazonaws.com/onboard2.svg',
            text: 'Withdraw only what you need, and repay flexibly',
        },
        {
            id: '3',
            image: 'https://volt-images.s3.ap-south-1.amazonaws.com/onboard3.svg',
            text: 'Let your savings grow',
        },
    ],
    textColor: ColorTokens.Black,
};
export const argTypes = {
    textColor: {
        control: 'select',
        options: [
            ...Object.values(ColorTokens).filter((k) => typeof k === 'string'),
        ],
    },
};
